import { Dialog, DialogContent, IconButton, Checkbox, Button, Autocomplete, TextField, Snackbar, Alert, Portal } from '@mui/material'
import React, { useRef, useState } from 'react'
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import TimePicker from '@mui/lab/TimePicker';
import ClearRoundedIcon from '@mui/icons-material/ClearRounded';

import { listCenter } from './constant'
import './FormReg.css'
import axios from 'axios';
export default function FormReg(props) {
    const parentName = useRef()
    const numberPhone = useRef()
    const province = useRef()
    const fullName = useRef()
    const email = useRef()
    const DOB = useRef()
    const center = useRef()
    const advisetime = useRef()
    const typeStudy = useRef()
    const [messErrSignUp, setmessErrSignUp] = useState("")
    const [typeSignUp, settypeSignUp] = useState("")
    const [messNoti, setmessNoti] = useState("Đăng ký thành công")
    const [isRequestSignUp, setisRequestSignUp] = useState(false)
    const [isAgreeRule, setisAgreeRule] = useState(false)
    const [isHaveErr, setisHaveErr] = useState(false)
    const [isOpenNoti, setIsOpenNoti] = useState(false)

    const handleSubmitSignup = (e) => {

        const user_parent_name = parentName.current.value
        const user_phone = numberPhone.current.value
        const user_province = province.current.value
        const user_mail = email.current.value
        const user_apax_name = fullName.current.value
        const user_birth_year = DOB.current.value
        const user_typeStudy = typeStudy.current.value
        const user_center = center.current.value
        const user_advise_time = advisetime.current.value
        setmessErrSignUp("Password nhập lại không đúng")
        if (user_advise_time == "" || user_province == "" || user_typeStudy == "" || user_center == "" || user_parent_name == "" || user_apax_name == "" || user_phone == "" || user_birth_year == "" || typeSignUp == "") setmessErrSignUp("Vui lòng điền đầy đủ các trường thông tin bắt buộc")
        else if (parseInt(user_birth_year) < 1870 || parseInt(user_birth_year) > 2020) {
            setmessErrSignUp("Năm sinh vừa nhập không đúng")
        }
        else {
            setmessErrSignUp("")
            setisRequestSignUp(true)
            const data = {
                user_parent_name,
                user_phone,
                user_province,
                user_mail,
                user_apax_name,
                user_birth_year,
                user_typeStudy,
                user_center,
                user_type: typeSignUp,
                user_advise_time
            }
            console.log(data)
            axios({ method: "POST", url: "https://api-super.com:8304/advise/commit", data }).then(res => {
                if (res.data.responseCode == "200") {
                    setisRequestSignUp(false)
                    setisHaveErr(false)
                    setIsOpenNoti(true)
                    setmessNoti("Đăng ký thành công")
                    setTimeout(() => {
                        props.handleCloseDialog()
                    }, 2000)

                }
                else {
                    setmessNoti("Có lỗi xảy ra, vui lòng thử lại")
                    setIsOpenNoti(true)
                    setisHaveErr(true)
                    setisRequestSignUp(false)
                }

            }).catch(err => {
                setmessNoti("Có lỗi xảy ra, vui lòng thử lại")
                setIsOpenNoti(true)
                setisHaveErr(true)
                setisRequestSignUp(false)
            })
        }
    }

    return (
        <Dialog
            fullWidth={true}
            maxWidth={'sm'}
            open={props.isOpenDialogReg}>

            <DialogContent style={{ paddingBottom: "10px", backgroundColor: "#ffda73", position: "relative" }}>

                <IconButton className="close-dialog-btn" onClick={() => props.handleCloseDialog()}>
                    <ClearRoundedIcon />
                </IconButton>
                <input name="username" type="username" style={{ display: "none" }} autocomplete="on" />
                <input name="password" type="password" style={{ display: "none" }} autocomplete="on" />
                <h2 className="login-title">Thông tin đăng ký</h2>
                <div className="container">
                    <div className="row">
                        <div className="col-md-10 offset-md-1">

                            <div className="typeSignUp-container mb-3">

                                <p>BẠN MUỐN</p>
                                <div className="d-flex">

                                    <div className="checkbox-container pr-4" style={{ display: "inline-block", borderRight: "2px solid black" }}>
                                        <Checkbox
                                            checked={typeSignUp == "NHẬN HỌC BỔNG"}
                                            onChange={() => settypeSignUp("NHẬN HỌC BỔNG")}
                                        />
                                        <span>NHẬN HỌC BỔNG</span>

                                    </div>
                                    <div className="checkbox-container ml-3">

                                        <Checkbox
                                            checked={typeSignUp == "TẶNG HỌC BỔNG"}
                                            onChange={() => settypeSignUp("TẶNG HỌC BỔNG")}
                                        />
                                        <span>TẶNG HỌC BỔNG</span>
                                    </div>
                                </div>
                                {messErrSignUp != "" && typeSignUp == "" ?
                                    <span className="d-block text-danger text-center mt-2">
                                        Vui lòng chọn loại đăng ký
                                    </span>
                                    : null}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="input-signup-container">
                    <div className="input-field">
                        <input autoComplete="rutjfkde" role="presentation" className={messErrSignUp != "" && parentName.current.value == "" ? "input-err" : ""} type="text" placeholder="Họ tên phụ huynh" ref={parentName} />
                    </div>
                </div>
                <div className="input-signup-container">
                    <div className="input-field">
                        <input autoComplete="rutjfkde" role="presentation" className={messErrSignUp != "" && numberPhone.current.value == "" ? "input-err" : ""} type="number" placeholder="Số điện thoại" ref={numberPhone} />
                    </div>
                </div>
                <div className="input-signup-container">
                    <div className="input-field">
                        <input autoComplete="rutjfkde" role="presentation" className={messErrSignUp != "" && province.current.value == "" ? "input-err" : ""} type="text" placeholder="Tỉnh/Thành phố" ref={province} />
                    </div>
                </div>
                <div className="input-signup-container">
                    <div className="input-field">
                        <input type="email" placeholder="Email" ref={email} />
                    </div>
                </div>
                <div className="input-signup-container">
                    <div className="input-field">
                        <input autoComplete="rutjfkde" role="presentation" className={messErrSignUp != "" && fullName.current.value == "" ? "input-err" : ""} type="text" placeholder="Tên học viên" ref={fullName} />
                    </div>
                </div>

                <div className="input-signup-container">
                    <div className="input-field">
                        <input autoComplete="rutjfkde" role="presentation" className={messErrSignUp != "" && DOB.current.value == "" ? "input-err" : ""} type="number" placeholder="Năm sinh" ref={DOB} />
                    </div>
                </div>


                <div className="input-signup-container">
                    <div className="input-field">
                        <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            options={['Offline tại trung tâm', 'Online AVS']}
                            sx={{ width: 300 }}
                            renderInput={(params) => <TextField
                                className="inputSelect"
                                inputRef={typeStudy}
                                {...params} placeholder="Khoá học mong muốn" title="" />}
                        />

                    </div>
                </div>

                <div className="input-signup-container">
                    <div className="input-field">
                        <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            options={listCenter}
                            sx={{ width: 300 }}
                            renderInput={(params) => <TextField
                                className="inputSelect"
                                inputRef={center}
                                {...params} placeholder="Trung tâm muốn đăng ký" title="" />}
                        />
                    </div>
                </div>
                {messErrSignUp != "" ?
                    <p className="text-danger text-center mt-3 font-weight-bold" >
                        {messErrSignUp}
                    </p>
                    : null}
                <div className="container">
                    <div className="row">
                        <div className="col-md-11 offset-md-1 mt-3">
                            <span style={{ fontFamily: "iCielPantonBoldItalic", fontSize: "1.33rem" }}>
                                Thời gian có thể nghe tư vấn:
                            </span>
                            <input type="text" className="ml-2" ref={advisetime} />
                            <div className=" pr-4" style={{ display: "inline-block" }}>
                                <div className="row mt-3">
                                    <div className="col-1">

                                        <Checkbox
                                            checked={isAgreeRule}
                                            onChange={() => setisAgreeRule(!isAgreeRule)}
                                        />
                                    </div>
                                    <div className="col-11">
                                        <span className="agree-rule-text">Tôi đồng ý với điều kiện của chương trình và nhận các thông tin tư vấn từ Apax.</span>
                                    </div>

                                </div>
                            </div>
                            <span style={{ fontFamily: "iCielPantonSemiBoldItalic" }}>
                                Lưu ý: Apax sẽ gửi voucher học bổng trong 48 tiếng qua email và liên hệ để tư vấn sử dụng học bổng qua số điện thoại được cung cấp. Xin quý khách vui lòng lưu ý nghe máy để được hỗ trợ.
                            </span>
                        </div>
                    </div>
                </div>
                <Portal>
                    <Snackbar className="noti-snackbar" style={{ marginTop: "3em" }} anchorOrigin={{ vertical: "top", horizontal: "right" }} open={isOpenNoti} autoHideDuration={2000} onClose={() => setIsOpenNoti(false)}>

                        <Alert elevation={6} onClose={() => setIsOpenNoti(false)} severity={isHaveErr ? "error" : "success"}>

                            <span style={{ fontSize: "2.2rem" }}>
                                {messNoti}
                            </span>
                        </Alert>
                    </Snackbar>
                </Portal>
                <div>
                    <div className="text-center">

                        <Button disabled={!isAgreeRule} onClick={() => handleSubmitSignup()} className="btn-signup content-middle" variant="contained">
                            {isRequestSignUp ?
                                <div className="lds-ellipsis"><div></div><div></div><div></div></div> :
                                <span className="login-btn-text">GỬI ĐI</span>
                            }
                        </Button>

                    </div>

                </div>
            </DialogContent>
        </Dialog>
    )
}
